import { h, Component } from 'preact'
import ProjectsAPI from '../api/ProjectsAPI'
import Projects from '../components/Projects'
import LoadMoreProjects from '../components/LoadMoreProjects'
import BranchFilter from './BranchFilter'

// Tell Babel to transform JSX into h() calls:
/** @jsx h */

class App extends Component {

    constructor (props) {
        super(props)
        this.state = {
            projects: [],
            count: 8,
            offset: 0,
            currentBranch: '',
            totalAmountProjects: null,
            loadedAllProjects: false,
            isLoading: true,
            error: false,
        }

        this.handleLoadMore = this.handleLoadMore.bind(this)
        this.handleBranchChoice = this.handleBranchChoice.bind(this)
    }

    componentDidMount () {

        // check if href hash exists and is an integer
        if (location.hash &&
            Number.isInteger(parseInt(location.hash.substr(1)))) {

            this.setState({
                currentBranch: location.hash.substr(1),
            }, this.fetchProjects)

        } else {
            this.fetchProjects()
        }
    }

    componentDidUpdate () {
        window.dispatchEvent(new Event('resize'))
    }

    fetchProjects () {
        this.setState({ isLoading: true })

        ProjectsAPI.all(this.state, this.props.sub_id).then(response => {
            this.setState({
                totalAmountProjects: response.headers.get('x-wp-total'),
            })
            return response.json()
        }).then(data => {
            window.setTimeout(() => {
                this.setState({
                    projects: [...this.state.projects, ...data],
                    loadedAllProjects: false,
                    isLoading: false,
                })
                this.verifyLoadedAllPosts()
            }, 500)
        }).catch(error => {
            this.setState({
                error: true,
                isLoading: false,
            })
        })
    }

    verifyLoadedAllPosts () {
        if (this.state.totalAmountProjects == this.state.projects.length) {
            return this.setState({
                loadedAllProjects: true,
            })
        }

        return false
    }

    handleLoadMore () {
        this.setState((prevState) => {
            return {
                offset: prevState.offset + this.state.count,
            }
        }, this.fetchProjects)
    }

    handleBranchChoice (value) {
        this.setState(() => {
            return {
                currentBranch: value,
                projects: [],
                offset: 0,
            }
        }, this.fetchProjects)
    }

    render () {
        return (
            <div className="c-projects-app">

                <BranchFilter
                    currentBranch={this.state.currentBranch}
                    onSelectBranch={this.handleBranchChoice}
                    language={this.props.language}
                    slugs={this.props.branch_slugs}
                />

                <Projects
                    projects={this.state.projects}
                    loading={this.state.isLoading}
                    error={this.state.error}
                    language={this.props.language}
                />

            </div>
        )
    }
}

export default App

// WEBPACK FOOTER //
// ./src/js/projects/containers/App.js
